import type { AxiosResponse } from 'axios';

import axiosWithAuth from '@/lib/axios';
import { asyncErrorHandler } from '@/utils/asyncErrorHandler';

import type { TodoItem } from './types';

export const fetchTodoList = async (url: string) => {
  try {
    const response: AxiosResponse<TodoItem[]> = await axiosWithAuth({
      url,
      method: 'GET',
    });
    const result = response.data;
    return result;
  } catch (error) {
    const errObj = error.response.data;
    const errMsg = errObj.displayMessage || '待辦提醒列表獲取失敗!';
    asyncErrorHandler(errObj, errMsg, 'Error-fetchTodoList:');
    return [];
  }
};
